/* globals $: true, Codsec: true*/

this.Codsec = this.Codsec || {};

this.Codsec.billing = {
	makePurchase: function(stripeToken, scanAmount, euVat, couponCode) {
		return executePost('/purchase/scans', {
			stripeToken : stripeToken.id,
			scanAmount  : scanAmount,
			euVat       : euVat,
			couponCode  : couponCode
		})
	},
	getPrice: function(scanAmount, euVat, couponCode) {
		return executeGet('/purchase/scans/price', {
			scanAmount : scanAmount,
			euVat      : euVat,
			couponCode : couponCode
		});
	}
};
